// extracted by css-extract-rspack-plugin
export default {"cls1":"ClaimEvaluationRow-cls1_0q-","cls2":"ClaimEvaluationRow-cls2_W4N ClaimEvaluationRow-cls1_0q-"};